import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, HostBinding } from '@angular/core';
import { FormBaseComponent } from '../../models/form-base-component';
import { FormDateRangeField } from './form-date-range.model';
import { FormFieldService } from '../../services/form-field.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'gio-form-date-range',
  templateUrl: './form-date-range.component.html',
  styleUrls: ['./form-date-range.component.scss'],
  host: {
    '[class]': 'classNames'
  },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormDateRangeComponent<N = any> extends FormBaseComponent<FormDateRangeField<N>> {

  @HostBinding('style')
  get myStyle() { return this.getHostStyles(); }

  constructor(
    cd: ChangeDetectorRef,
    public _service: FormFieldService,
    sanitizer: DomSanitizer
  ) { super(cd, _service, sanitizer); }

  onComponentInit() { }
  onComponentDestroy() { }

}
